import { render } from "./trust-data-pagesettings.html?vue&type=template&id=5b56ebb0&scoped=true&ts=true&external"
import script from "./trust-data-pagesettings.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-pagesettings.ts?vue&type=script&lang=ts&external"

import "./trust-data-pagesettings.scss?vue&type=style&index=0&id=5b56ebb0&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b56ebb0"]])

export default __exports__